import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import searchIcon from '../../../assets/icons/icon-search.svg';
import linkedinIcon from '../../../assets/icons/icon-linkedin.svg';
import instagramIcon from '../../../assets/icons/icon-instagram.svg';
import facebookIcon from '../../../assets/icons/icon-facebook.svg';
import twitterIcon from '../../../assets/icons/icon-twitter.svg';
import slideArrowLeft from '../../../assets/icons/slide-arrow-left.svg';
import slideArrowRight from '../../../assets/icons/slide-arrow-right.svg';
import apple from '../../../assets/icons/apple-icon.svg';
import prevWeek from '../../../assets/icons/prev-week.svg';
import nextWeek from '../../../assets/icons/next-week.svg';
import info from '../../../assets/icons/info.svg';
import calendar from '../../../assets/icons/icon-calendar.svg';
import arrowCircleLeft from '../../../assets/icons/arrow-circle-left.svg';
import arrowCircleRight from '../../../assets/icons/arrow-circle-right.svg';
import sendArrow from '../../../assets/icons/send-arrow.svg';
import sms from '../../../assets/icons/icon-sms.svg';
import email from '../../../assets/icons/icon-email.svg';

export const GLYPHS = {
  SEARCH: searchIcon,
  LINKEDIN: linkedinIcon,
  INSTAGRAM: instagramIcon,
  FACEBOOK: facebookIcon,
  TWITTER: twitterIcon,
  SLIDE_ARROW_LEFT: slideArrowLeft,
  SLIDE_ARROW_RIGHT: slideArrowRight,
  APPLE: apple,
  PREV_WEEK: prevWeek,
  NEXT_WEEK: nextWeek,
  INFO: info,
  CALENDAR: calendar,
  ARROW_CIRCLE_LEFT: arrowCircleLeft,
  ARROW_CIRCLE_RIGHT: arrowCircleRight,
  SEND_ARROW: sendArrow,
  SMS: sms,
  EMAIL: email,
};

const Icon = ({ glyph, size, className }) => {
  const classes = classnames(
    'o-icon',
    { 'o-icon--medium': size === 'medium' },
    { 'o-icon--small': size === 'small' },
    className,
  );

  return (
    <svg className={classes} role="img">
      <use xlinkHref={glyph} />
    </svg>
  );
};
Icon.propTypes = {
  glyph: PropTypes.string.isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
};
Icon.defaultProps = {
  size: '',
  className: '',
};

export default Icon;



// WEBPACK FOOTER //
// ./src/app/components/Icon.jsx